export default __webpack_public_path__ + "static/media/icon-twitter.f6a2a695.svg";